module.exports = __webpack_public_path__ + "img/HC2024-112.3d80419f.jpg";